import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import getDataById from "../../../hooks/getDataById";
import { FaArrowLeft } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import LoadingSpinner from "../../../components/utils/LoadingSpinner";
import i18next from "i18next";
import axios from "../../../components/utils/Interceptors";
import {
  Form,
  Input,
  Button,
  Card,
  Typography,
  Space,
  Row,
  Col,
} from "antd";

const { Title } = Typography;

const EditCustomerQuery = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const user = JSON.parse(localStorage.getItem("user"));
  const { state } = useLocation();
  const navigate = useNavigate();
  const { register, setValue, handleSubmit } = useForm();
  const selectLanguage = i18next.language;
  const [form] = Form.useForm();

  useEffect(() => {
    setLoading(true);
    const getQueries = async () => {
      const res = await getDataById("vendor/getbyidcustomerquery", state);
      if (res.status_code === 200) {
        const data = res.data;
        form.setFieldsValue({
          customer_name: data.customer_name,
          customer_email: data.customer_email,
          id: data.id,
          query: data.query,
          query_ar: data.query_ar,
          resolution: data.resolution,
          resolution_ar: data.resolution_ar,
        });
      }
      setLoading(false);
    };
    getQueries();
  }, [form, state]);

  const onFinish = async (values) => {
    setLoading(true);
    const info = {
      id: values.id,
      resolution: values.resolution,
      resolution_ar: values.resolution_ar,
    };

    try {
      const res = await axios.patch(
        `${process.env.REACT_APP_APIURL}/vendor/updatecustomerquery`,
        JSON.stringify(info),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.token}`,
          },
        }
      );
      const response = await res.data;
      if (response?.status_code === 200) {
        toast.success(response.message);
        navigate("/vendor/product-queries");
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error(t("An error occurred"));
    }
    setLoading(false);
  };

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <Row justify="center" className="mt-4 mb-20">
      <Col xs={24} sm={20} md={16} lg={12}>
        <Card title={t("Update Customer Query")} extra={
           <button className=" btn btn-primary btn-sm w-full rounded-md text-white"  onClick={() => navigate("/vendor/product-queries")}> <FaArrowLeft />{t("add_new_product_back")}</button>
        }>
          <Form
            layout="vertical"
            form={form}
            onFinish={onFinish}
            initialValues={{}}
          >
            <Form.Item name="customer_name" label={t("query_cust_name")}>
              <Input disabled />
            </Form.Item>

            <Form.Item name="id" hidden>
              <Input hidden />
            </Form.Item>

            <Form.Item name="customer_email" label={t("query_cust_email")}>
              <Input disabled />
            </Form.Item>

            <Form.Item name="query" label={t("Query")}>
              <Input disabled />
            </Form.Item>

            <Form.Item name="query_ar" label={`${t("Query")} (${t("in Arabic")})`}>
              <Input disabled />
            </Form.Item>

            <Form.Item
              name="resolution"
              label={t("Resolution")}
              rules={[{ required: true, message: t("Please input resolution") }]}
            >
              <Input placeholder={t("Resolution")} />
            </Form.Item>

            <Form.Item
              name="resolution_ar"
              label={`${t("Resolution")} (${t("in Arabic")})`}
              rules={[{ required: true, message: t("Please input Arabic resolution") }]}
            >
              <Input placeholder={t("Resolution")} />
            </Form.Item>

            <Form.Item>
              <button className=" btn btn-primary w-full rounded-md text-white" type="submit">
                {t("vd_pc_btn2")}
              </button>
            </Form.Item>
          </Form>
        </Card>
      </Col>
    </Row>
  );
};

export default EditCustomerQuery;

